const initialState = {
  script: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'LOAD_SCRIPT':
      return { script: action.script };
    case 'SET_SCRIPT_FIELD':
      return { ...state, ...action.payload };
    case 'CLEAR_SCRIPT':
      return initialState;
    default:
      return state;
  }
}
